import { skipToken } from "@apollo/client";
import dayjs from "dayjs";
import {
    BusinessCode,
    SavedQuotesQueryVariables,
    useSavedQuotesSuspenseQuery,
} from "generated/graphql";
import { useMemo } from "react";

export const useSavedQuotes = (
    nbDaysQuoteIsVisible?: number | null,
    variables?: Partial<SavedQuotesQueryVariables>,
) => {
    const expirationDateRange = useMemo(
        () =>
            typeof nbDaysQuoteIsVisible === "number"
                ? dayjs()
                      .subtract(nbDaysQuoteIsVisible, "days")
                      .startOf("day")
                      .toISOString()
                : undefined,
        [nbDaysQuoteIsVisible],
    );
    const { data } = useSavedQuotesSuspenseQuery(
        variables?.filter?.customerId
            ? {
                  variables: {
                      language:
                          process.env.NEXT_PUBLIC_STORYBLOK_LANGUAGE ?? "",
                      filter: {
                          expirationDateRange: expirationDateRange
                              ? {
                                    from: expirationDateRange,
                                }
                              : undefined,
                          ...variables.filter,
                          businessCode: process.env
                              .NEXT_PUBLIC_BUSINESS_CODE as BusinessCode,
                          isSaved: true,
                      },
                      pagination: {
                          ...variables.pagination,
                          limit: 3,
                      },
                      sort: variables.sort,
                  },
              }
            : skipToken,
    );

    return { ...data?.quotes };
};
